(function () {
  'use strict';
  const fieldNames = ['subject', 'headline', 'body', 'product', 'detail', 'price', 'cta'];
  function initialize() {
    document.querySelectorAll('[data-home-play]').forEach(root => {
      if (root.dataset.homePlayReady) return;
      let data;
      try { data = JSON.parse(root.querySelector('[data-home-play-data]').textContent); } catch (_) { return; }
      if (!data?.before || !data.after || !Array.isArray(data.steps) || data.steps.length !== 3) return;
      if (!fieldNames.every(field => typeof data.before[field] === 'string' && typeof data.after[field] === 'string')) return;
      if (!data.steps.every(step => Array.isArray(step.fields) && step.fields.every(field => fieldNames.includes(field)))) return;
      const q = selector => root.querySelector(selector);
      const fields = Object.fromEntries(fieldNames.map(field => [field, q(`[data-email-field="${field}"]`)]));
      if (Object.values(fields).some(field => !field)) return;
      root.dataset.homePlayReady = 'true';
      const apply = q('[data-apply-fix]'), compare = q('[data-compare-original]');
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      let completed = 0, original = false, job = null, frame = null, generation = 0;
      const set = (selector, value) => { const node = q(selector); if (node) node.textContent = value; };
      const announce = message => set('[data-review-status]', message);
      const track = name => document.dispatchEvent(new CustomEvent('myuser:tool-event', { detail: { name } }));
      function values() {
        const result = { ...data.before };
        if (!original) data.steps.slice(0, completed).forEach(step => step.fields.forEach(field => { result[field] = data.after[field]; }));
        return result;
      }
      function paintEmail() {
        const copy = values();
        fieldNames.forEach(field => { fields[field].textContent = copy[field]; fields[field].removeAttribute('data-typing'); });
        root.querySelectorAll('[data-edit-region]').forEach(region => {
          region.dataset.active = String(!original && completed < 3 && region.dataset.editRegion === data.steps[completed].id);
          region.dataset.fixed = String(!original && data.steps.slice(0, completed).some(step => step.id === region.dataset.editRegion));
          region.removeAttribute('data-selecting');
        });
      }
      function paintControls() {
        const done = completed === 3;
        root.dataset.completed = String(completed);
        root.dataset.step = done ? 'done' : data.steps[completed].id;
        root.dataset.state = job ? 'applying' : done ? 'done' : 'ready';
        root.dataset.original = String(original);
        set('[data-review-progress]', `${completed} of 3 fixes made`);
        set('[data-draft-label]', original ? 'Original draft' : done ? 'Your fixed email' : completed ? 'Your email, so far' : 'Your draft');
        q('[data-review-current]').hidden = done;
        q('[data-review-complete]').hidden = !done;
        compare.hidden = !done;
        compare.disabled = Boolean(job);
        compare.setAttribute('aria-pressed', String(original));
        compare.textContent = original ? 'Back to the fixed email' : 'See the original';
        apply.disabled = Boolean(job);
        q('[data-sample-link]').disabled = Boolean(job);
        apply.setAttribute('aria-busy', String(Boolean(job)));
        data.steps.forEach((step, index) => {
          const item = q(`[data-fix-status="${step.id}"]`);
          item.dataset.done = String(index < completed);
          item.dataset.current = String(index === completed);
          if (index === completed) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current');
        });
        if (!done) {
          const step = data.steps[completed];
          set('[data-review-step]', `${completed + 1} of 3 · ${step.label}`);
          set('[data-review-title]', step.title);
          set('[data-review-reason]', step.reason);
          set('[data-review-suggestion]', step.suggestion);
          apply.textContent = job ? 'Making this change…' : step.action;
        }
      }
      function closeDestination(returnFocus = false) {
        q('[data-destination]').hidden = true;
        if (returnFocus) q('[data-sample-link]').focus({ preventScroll: true });
      }
      function cancel() {
        generation++;
        if (frame !== null) window.cancelAnimationFrame(frame);
        frame = null; job = null;
      }
      function revealEdit(step) {
        const region = q(`[data-edit-region="${step.id}"]`);
        const rect = region.getBoundingClientRect();
        const headerBottom = document.querySelector('.site-header')?.getBoundingClientRect().bottom || 0;
        const top = Math.max(0, headerBottom) + 20, bottom = window.innerHeight - 24;
        if (!rect.height || (rect.top >= top && rect.bottom <= bottom)) return 0;
        // Keep the page's own scroll, and only move when the change is out of view.
        // Leave room above the email for its advice when the screen permits it.
        const targetTop = Math.max(top, bottom - rect.height - 32);
        window.scrollBy({ top: rect.top - targetTop, behavior: preference.matches ? 'instant' : 'smooth' });
        return preference.matches ? 0 : 360;
      }
      function finish() {
        if (!job) return;
        const name = data.steps[completed].label, hadFocus = document.activeElement === apply;
        cancel(); completed++;
        paintEmail(); paintControls();
        announce(`${name} fixed. ${completed === 3 ? 'All three fixes are in the email. Try its cart button, or see the original.' : 'Next: ' + data.steps[completed].label.toLowerCase() + '.'}`);
        if (completed === 3) {
          track('homepage_review_completed');
          if (hadFocus) compare.focus({ preventScroll: true });
        }
      }
      function animate(now, token) {
        if (!job || generation !== token) return;
        frame = null;
        if (job.started === null) job.started = now;
        const elapsed = now - job.started - job.revealDelay, step = data.steps[completed];
        if (elapsed < 0) { frame = window.requestAnimationFrame(time => animate(time, token)); return; }
        const region = q(`[data-edit-region="${step.id}"]`);
        region.dataset.selecting = String(elapsed < 180);
        const progress = Math.max(0, Math.min(1, (elapsed - 180) / job.duration));
        const count = Math.floor(progress * job.total);
        let used = 0, cursorSet = false;
        step.fields.forEach(field => {
          const replacement = data.after[field], length = replacement.length;
          fields[field].removeAttribute('data-typing');
          if (elapsed < 180) return;
          fields[field].textContent = replacement.slice(0, Math.max(0, Math.min(length, count - used)));
          if (!cursorSet && count >= used && count < used + length) {
            fields[field].setAttribute('data-typing', 'true'); cursorSet = true;
          }
          used += length;
        });
        if (progress === 1) { finish(); return; }
        frame = window.requestAnimationFrame(time => animate(time, token));
      }
      apply.addEventListener('click', () => {
        if (job || completed === 3) return;
        closeDestination(); original = false;
        const step = data.steps[completed];
        job = { started: null, revealDelay: revealEdit(step), duration: step.id === 'message' ? 1300 : 850, total: step.fields.reduce((count, field) => count + data.after[field].length, 0) };
        paintControls();
        announce('Changing the ' + step.label.toLowerCase() + '.');
        track('homepage_review_fix_used');
        if (preference.matches || document.hidden) finish();
        else { const token = generation; frame = window.requestAnimationFrame(time => animate(time, token)); }
      });
      compare.addEventListener('click', () => {
        if (completed !== 3 || job) return;
        closeDestination(); original = !original; paintEmail(); paintControls();
        announce(original ? 'Original draft shown. Your fixes are kept.' : 'Fixed email shown.');
      });
      q('[data-review-reset]').addEventListener('click', () => {
        cancel(); closeDestination(); completed = 0; original = false;
        paintEmail(); paintControls(); announce('Back to the draft. Start with its subject line.');
      });
      q('[data-sample-link]').addEventListener('click', () => {
        if (job) return;
        const cart = completed === 3 && !original;
        const sheet = q('[data-destination]');
        sheet.dataset.kind = cart ? 'cart' : 'store';
        set('[data-destination-title]', cart ? 'Maya’s saved cart' : 'Store page');
        set('[data-destination-copy]', cart
          ? 'Her blue tote is here, ready to buy. This is a sample cart. Add your own cart link when you send.'
          : 'This button takes her to all the bags. She has to find her tote again. Close this view to keep fixing the email.');
        sheet.hidden = false;
        q('[data-close-destination]').focus({ preventScroll: true });
        announce(cart ? 'The new button opens this sample saved cart.' : 'The draft button leads to the full store.');
      });
      q('[data-close-destination]').addEventListener('click', () => closeDestination(true));
      root.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !q('[data-destination]').hidden) { event.preventDefault(); closeDestination(true); }
      });
      // Finish a user-requested edit when motion becomes unavailable; never
      // replay a half-written value or keep work running in a hidden page.
      preference.addEventListener?.('change', () => { if (preference.matches) finish(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) finish(); });
      window.addEventListener('pagehide', finish);
      paintEmail(); paintControls();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
